import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  position: relative;\n  touch-action: none;\n  list-style: none;\n  cursor: pointer;\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: ", ";\n  width: ", ";\n  right: auto;\n  height: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: absolute;\n  left: ", ";\n  right: auto;\n  width: ", ";\n  height: ", ";\n  margin-top: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  cursor: pointer;\n  transform: translate(-50%);\n\n  &:hover {\n    box-shadow: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: absolute;\n  width: 100%;\n  height: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  transition: background-color 0.3s;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useRef, useState, forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '../grid/Grid';
import { Tooltip } from '../tooltip/Tooltip';
import { useDefaultRef } from '../utils/useDefaultRef';
import { useEventCallback } from '../utils/useEventCallback';
import { themeGet } from '@styled-system/theme-get';
var Rail = styled.div(_templateObject(), themeGet('slider.rail.height'), themeGet('slider.rail.borderRadius'), themeGet('slider.rail.backgroundColor'));
var Thumb = styled.div(_templateObject2(), function (props) {
  return props.left;
}, themeGet('slider.thumb.width'), themeGet('slider.thumb.height'), themeGet('slider.thumb.marginTop'), themeGet('slider.thumb.backgroundColor'), themeGet('slider.thumb.border'), themeGet('slider.thumb.borderRadius'), themeGet('slider.thumb.hover.boxShadow'));
var Track = styled.div(_templateObject3(), function (props) {
  return props.minValue || 0;
}, function (props) {
  return props.maxValue || 0;
}, themeGet('slider.track.height'), themeGet('slider.track.color'), themeGet('slider.track.borderRadius'));
var Wrap = styled(Box).attrs({
  height: '12px',
  py: '4px'
})(_templateObject4(), Rail, themeGet('slider.rail.hover.backgroundColor'));

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function getDecimalPrecision(num) {
  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
  if (Math.abs(num) < 1) {
    var parts = num.toExponential().split('e-');
    var matissaDecimalPart = parts[0].split('.')[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }

  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function valueToPercent(value, min, max) {
  return (value - min) / (max - min) * 100;
}

function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}

function roundValueToStep(value, step, min) {
  return Number((Math.round((value - min) / step) * step + min).toFixed(getDecimalPrecision(step)));
}

var clamp = function clamp(max, min) {
  return function (value) {
    return Math.max(Math.min(max, value), min);
  };
};

export var Slider =
/*#__PURE__*/
forwardRef(function Slider(_ref, ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      propValue = _ref.value,
      onChange = _ref.onChange,
      onMouseDown = _ref.onMouseDown;
  var isControlled = useRef(propValue != null);

  var _useState = useState(clamp(max, min)(propValue || 100)),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var mouseDownPosition = useRef();

  var _useDefaultRef = useDefaultRef(ref),
      _useDefaultRef2 = _slicedToArray(_useDefaultRef, 2),
      sliderRef = _useDefaultRef2[0],
      setSliderRef = _useDefaultRef2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showTooltip = _useState4[0],
      setShowTooltip = _useState4[1];

  if (isControlled.current && propValue !== value) {
    setValue(propValue);
  }

  var handleMouseMove = useEventCallback(function (event) {
    event.stopPropagation();

    var _sliderRef$current$ge = sliderRef.current.getBoundingClientRect(),
        left = _sliderRef$current$ge.left,
        width = _sliderRef$current$ge.width;

    var pageX = event.pageX || event.changedTouches[0].pageX;
    var p = (pageX - left) / width;
    var result = clamp(max, min)(percentToValue(p, min, max));

    if (step) {
      result = roundValueToStep(result, step, min);
    }

    if (!isControlled.current) {
      setValue(result);
    }

    if (onChange) {
      onChange(result);
    }
  });
  var handleMouseDown = useEventCallback(function (event) {
    if (onMouseDown) {
      onMouseDown(event);
    }

    event.preventDefault();
    event.stopPropagation();
    setShowTooltip(true);
    mouseDownPosition.current = event.pageX;
    var doc = ownerDocument(sliderRef.current);
    doc.addEventListener('mousemove', handleMouseMove);
    doc.addEventListener('mouseup', handleMouseUp);
    doc.addEventListener('touchmove', handleMouseMove);
    doc.addEventListener('touchend', handleMouseUp);
  });
  var handleMouseUp = useEventCallback(function () {
    setShowTooltip(false);
    var doc = ownerDocument(sliderRef.current);
    doc.removeEventListener('mousemove', handleMouseMove);
    doc.removeEventListener('mouseup', handleMouseUp);
    doc.removeEventListener('touchmove', handleMouseMove);
    doc.removeEventListener('touchend', handleMouseUp);
  });
  var percent = valueToPercent(clamp(max, min)(value), min, max);
  return (
    /*#__PURE__*/
    React.createElement(Wrap, {
      ref: setSliderRef,
      onMouseDown: handleMouseMove
    },
    /*#__PURE__*/
    React.createElement(Rail, null),
    /*#__PURE__*/
    React.createElement(Track, {
      maxValue: "".concat(percent, "%")
    }),
    /*#__PURE__*/
    React.createElement(Tooltip, {
      title: value,
      open: showTooltip
    },
    /*#__PURE__*/
    React.createElement(Thumb, {
      left: "".concat(percent, "%"),
      onMouseDown: handleMouseDown,
      onTouchStart: handleMouseDown
    })))
  );
});
var defaultRangeValue = [0, 100];
export var RangeSlider =
/*#__PURE__*/
forwardRef(function RangeSlider(props, ref) {
  var _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      propValue = props.value,
      onChange = props.onChange;
  var isControlled = useRef(propValue != null);

  var _ref2 = propValue || defaultRangeValue,
      _ref3 = _slicedToArray(_ref2, 2),
      propLValue = _ref3[0],
      propRValue = _ref3[1];

  var _useState5 = useState(clamp(max, min)(propRValue)),
      _useState6 = _slicedToArray(_useState5, 2),
      rValue = _useState6[0],
      setRValue = _useState6[1];

  var _useState7 = useState(clamp(max, min)(propLValue)),
      _useState8 = _slicedToArray(_useState7, 2),
      lValue = _useState8[0],
      setLValue = _useState8[1];

  if (isControlled.current && propLValue !== lValue) {
    setLValue(propLValue);
  }

  if (isControlled.current && propRValue !== rValue) {
    setRValue(propRValue);
  }

  var mouseDownPosition = useRef();

  var _useDefaultRef3 = useDefaultRef(ref),
      _useDefaultRef4 = _slicedToArray(_useDefaultRef3, 2),
      sliderRef = _useDefaultRef4[0],
      setSliderRef = _useDefaultRef4[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showLTooltip = _useState10[0],
      setShowLTooltip = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showRTooltip = _useState12[0],
      setShowRTooltip = _useState12[1];

  var handleRValueChange = useEventCallback(function (event) {
    var _sliderRef$current$ge2 = sliderRef.current.getBoundingClientRect(),
        left = _sliderRef$current$ge2.left,
        width = _sliderRef$current$ge2.width;

    var pageX = event.pageX || event.changedTouches[0].pageX;
    var p = (pageX - left) / width;
    var result = clamp(max, lValue)(percentToValue(p, min, max));

    if (step) {
      result = roundValueToStep(result, step, min);
    }

    if (onChange) {
      onChange([lValue, result]);
    }

    if (!isControlled.current) {
      setRValue(result);
    }
  });
  var handleLValueChange = useEventCallback(function (event) {
    var _sliderRef$current$ge3 = sliderRef.current.getBoundingClientRect(),
        left = _sliderRef$current$ge3.left,
        width = _sliderRef$current$ge3.width;

    var pageX = event.pageX || event.changedTouches[0].pageX;
    var p = (pageX - left) / width;
    var result = clamp(rValue, min)(percentToValue(p, min, max));

    if (step) {
      result = roundValueToStep(result, step, min);
    }

    if (onChange) {
      onChange([result, rValue]);
    }

    if (!isControlled.current) {
      setLValue(result);
    }
  });
  var handleMinValueMouseDown = useEventCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    setShowLTooltip(true);
    mouseDownPosition.current = event.pageX;
    var doc = ownerDocument(sliderRef.current);
    doc.addEventListener('mousemove', handleLValueChange);
    doc.addEventListener('mouseup', handleMouseUp);
    doc.addEventListener('touchmove', handleLValueChange);
    doc.addEventListener('touchend', handleMouseUp);
  });
  var handleMaxValueMouseDown = useEventCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    setShowRTooltip(true);
    mouseDownPosition.current = event.pageX;
    var doc = ownerDocument(sliderRef.current);
    doc.addEventListener('mousemove', handleRValueChange);
    doc.addEventListener('mouseup', handleMouseUp);
    doc.addEventListener('touchmove', handleRValueChange);
    doc.addEventListener('touchend', handleMouseUp);
  });
  var handleMouseUp = useEventCallback(function () {
    var doc = ownerDocument(sliderRef.current);
    doc.removeEventListener('mousemove', handleRValueChange);
    doc.removeEventListener('mousemove', handleLValueChange);
    doc.removeEventListener('mouseup', handleMouseUp);
    doc.removeEventListener('touchmove', handleRValueChange);
    doc.removeEventListener('touchmove', handleLValueChange);
    doc.removeEventListener('touchend', handleMouseUp);
    setShowLTooltip(false);
    setShowRTooltip(false);
  });
  var handleClick = useEventCallback(function (event) {
    var _sliderRef$current$ge4 = sliderRef.current.getBoundingClientRect(),
        left = _sliderRef$current$ge4.left,
        width = _sliderRef$current$ge4.width;

    var pageX = event.pageX || event.changedTouches[0].pageX;
    var p = (pageX - left) / width;
    var result = clamp(max, min)(percentToValue(p, min, max));

    if (step) {
      result = roundValueToStep(result, step, min);
    }

    if (result <= lValue) {
      if (onChange) {
        onChange([result, rValue]);
      }

      if (isControlled.current) {
        setLValue(result);
      }
    } else {
      if (onChange) {
        onChange([lValue, result]);
      }

      if (isControlled.current) {
        setRValue(result);
      }
    }
  });
  var rPercent = valueToPercent(clamp(max, min)(rValue), min, max);
  var lPercent = valueToPercent(clamp(max, min)(lValue), min, max);
  return (
    /*#__PURE__*/
    React.createElement(Wrap, {
      ref: setSliderRef,
      onMouseDown: handleClick
    },
    /*#__PURE__*/
    React.createElement(Rail, null),
    /*#__PURE__*/
    React.createElement(Track, {
      minValue: "".concat(lPercent, "%"),
      maxValue: "".concat(rPercent - lPercent, "%")
    }),
    /*#__PURE__*/
    React.createElement(Tooltip, {
      title: lValue,
      open: showLTooltip
    },
    /*#__PURE__*/
    React.createElement(Thumb, {
      left: "".concat(lPercent, "%"),
      onMouseDown: handleMinValueMouseDown,
      onTouchStart: handleMinValueMouseDown
    })),
    /*#__PURE__*/
    React.createElement(Tooltip, {
      title: rValue,
      open: showRTooltip
    },
    /*#__PURE__*/
    React.createElement(Thumb, {
      left: "".concat(rPercent, "%"),
      onMouseDown: handleMaxValueMouseDown,
      onTouchStart: handleMaxValueMouseDown
    })))
  );
});